
function Home() {
    // 👇️ redirect to external URL
    window.location.replace('https://book.wander-collective.com');

    return null;
}

export default Home;